module.exports = __webpack_public_path__ + "static/banner-icon-1-5-6f6037481c286ac1b5b7ede808e0a314.svg";